import { AutoMap } from "@automapper/classes"

export class SamplerAddressDTO {
    @AutoMap()
    code: string = ''
    @AutoMap()
    displayName: string = ''
    @AutoMap()
    address: string = ''
    @AutoMap()
    samplerPuid: string = ''
    @AutoMap()
    latitude: number = -1
    @AutoMap()
    longitude: number = -1

}